/* Körbenézek – Shopify-téma viselkedései (fejléc, panorámasáv, videósáv, kereső, galéria, 360°).
   Külső függőség nincs; a 360°-os nézegető (Pannellum, MIT) csak megnyitáskor töltődik be. */
(() => {
  'use strict'
  const $ = (s, r = document) => r.querySelector(s)
  const $$ = (s, r = document) => [...r.querySelectorAll(s)]
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const norm = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim()
  const toast = (msg) => {
    const t = document.createElement('div')
    t.className = 'toast'; t.setAttribute('role', 'status'); t.textContent = msg
    document.body.appendChild(t); setTimeout(() => t.remove(), 2600)
  }

  /* ───────── Fejléc ───────── */
  function initHeader(root) {
    const header = $('.kb-header', root)
    if (!header || header.dataset.ready) return
    header.dataset.ready = '1'
    const btn = $('.kb-menu-btn', header), panel = $('.kb-mobile', header)
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 12)
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true })
    if (!btn || !panel) return
    const close = () => { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-label', btn.dataset.open); document.body.classList.remove('kb-menu-open') }
    btn.addEventListener('click', () => {
      if (!panel.hidden) return close()
      panel.style.setProperty('--kb-menu-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`)
      panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); btn.setAttribute('aria-label', btn.dataset.close)
      document.body.classList.add('kb-menu-open')
    })
    panel.addEventListener('click', (e) => { if (e.target.closest('a')) close() })
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) { close(); btn.focus() } })
    window.addEventListener('resize', () => { if (window.innerWidth >= 1024 && !panel.hidden) close() })
  }

  /* ───────── Panorámasáv iránytű-vonalzóval ───────── */
  function initPano(root) {
    $$('[data-kb-pano]', root).forEach((wrap) => {
      if (wrap.dataset.ready) return
      wrap.dataset.ready = '1'
      const track = $('.pano-track', wrap), scale = $('.ruler .scale', wrap), read = $('.ruler-read', wrap)
      if (!track) return
      if (scale && !scale.children.length) {
        const labels = { 0: 'É', 90: 'K', 180: 'D', 270: 'Ny' }
        let html = ''
        for (let d = -360; d <= 720; d += 5) {
          const deg = ((d % 360) + 360) % 360
          const major = deg % 90 === 0, mid = deg % 15 === 0
          html += `<span class="tick${major ? ' major' : mid ? ' mid' : ''}"><i></i>${major ? `<b>${labels[deg]}</b>` : mid ? `<b>${deg}°</b>` : ''}</span>`
        }
        scale.innerHTML = html
      }
      const update = () => {
        const max = track.scrollWidth - track.clientWidth
        const f = max > 0 ? track.scrollLeft / max : 0
        const deg = Math.round(f * 360) % 360
        if (scale) scale.style.transform = `translateX(${-f * 360 * 4}px)`
        if (read) read.textContent = `${deg}°`
      }
      track.addEventListener('scroll', update, { passive: true }); update()
      const step = () => track.clientWidth * 0.8
      $('[data-dir="prev"]', wrap)?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduced() ? 'auto' : 'smooth' }))
      $('[data-dir="next"]', wrap)?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduced() ? 'auto' : 'smooth' }))
      let down = false, startX = 0, startLeft = 0, moved = false
      track.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft; track.classList.add('dragging') })
      window.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - startX; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = startLeft - dx })
      window.addEventListener('pointerup', () => { down = false; track.classList.remove('dragging') })
      track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false } }, true)
    })
  }

  /* ───────── Videósáv: némított előnézet rámutatáskor / láthatóságkor ───────── */
  function initRails(root) {
    $$('[data-kb-rail]', root).forEach((wrap) => {
      if (wrap.dataset.ready) return
      wrap.dataset.ready = '1'
      const rail = $('.rail', wrap)
      const step = () => (rail ? rail.clientWidth * 0.8 : 300)
      $('[data-dir="prev"]', wrap)?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: reduced() ? 'auto' : 'smooth' }))
      $('[data-dir="next"]', wrap)?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: reduced() ? 'auto' : 'smooth' }))
      const cards = $$('.vcard', wrap).filter((c) => $('video', c))
      const play = (c) => { const v = $('video', c); if (!v || reduced()) return; v.muted = true; v.play().then(() => c.classList.add('playing')).catch(() => {}) }
      const stop = (c) => { const v = $('video', c); if (!v) return; v.pause(); c.classList.remove('playing') }
      const hover = window.matchMedia('(hover: hover)').matches
      if (hover) cards.forEach((c) => { c.addEventListener('mouseenter', () => play(c)); c.addEventListener('mouseleave', () => stop(c)) })
      else if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => entries.forEach((en) => (en.intersectionRatio > 0.75 ? play(en.target) : stop(en.target))), { threshold: [0, 0.75] })
        cards.forEach((c) => io.observe(c))
      }
    })
  }

  /* ───────── Felfedezés: azonnali szűrés a böngészőben ───────── */
  function initDirectory(root) {
    $$('[data-kb-dir]', root).forEach((wrap) => {
      if (wrap.dataset.ready) return
      wrap.dataset.ready = '1'
      const form = $('form', wrap), cards = $$('[data-kb-card]', wrap)
      const qIn = $('[name="q"]', form), cityIn = $('[name="varos"]', form), catIn = $('[name="kategoria"]', form)
      const countEl = $('[data-kb-count]', wrap), empty = $('[data-kb-empty]', wrap), grid = $('[data-kb-grid]', wrap)
      const chips = $$('[data-kb-chip]', wrap)
      const params = new URLSearchParams(location.search)
      const setSel = (sel, val) => {
        if (!sel || !val) return
        const opt = [...sel.options].find((o) => norm(o.value) === norm(val))
        if (opt) sel.value = opt.value
      }
      if (qIn && params.get('q')) qIn.value = params.get('q')
      setSel(cityIn, params.get('varos')); setSel(catIn, params.get('kategoria'))
      const apply = (push) => {
        const q = norm(qIn?.value), city = norm(cityIn?.value), cat = norm(catIn?.value)
        const words = q ? q.split(' ') : []
        let n = 0
        cards.forEach((c) => {
          if (c._hay === undefined) c._hay = norm(c.dataset.search)
          const hay = c._hay
          const ok = (!city || norm(c.dataset.city) === city) && (!cat || norm(c.dataset.cat) === cat) && words.every((w) => hay.includes(w))
          c.hidden = !ok; if (ok) n++
        })
        if (countEl) countEl.textContent = n
        if (empty) empty.hidden = n > 0
        if (grid) grid.hidden = n === 0
        chips.forEach((ch) => ch.setAttribute('aria-pressed', String(norm(ch.dataset.kbChip) === cat)))
        if (push) {
          const p = new URLSearchParams()
          if (qIn?.value.trim()) p.set('q', qIn.value.trim())
          if (cityIn?.value) p.set('varos', cityIn.value)
          if (catIn?.value) p.set('kategoria', catIn.value)
          history.replaceState(null, '', `${location.pathname}${[...p].length ? `?${p}` : ''}`)
        }
      }
      form?.addEventListener('submit', (e) => { e.preventDefault(); apply(true) })
      qIn?.addEventListener('input', () => apply(true))
      ;[cityIn, catIn].forEach((s) => s?.addEventListener('change', () => apply(true)))
      chips.forEach((ch) => ch.addEventListener('click', () => {
        if (!catIn) return
        const v = ch.dataset.kbChip
        if (!v || norm(catIn.value) === norm(v)) catIn.value = ''
        else setSel(catIn, v)
        apply(true)
      }))
      $$('[data-kb-reset]', wrap).forEach((b) => b.addEventListener('click', () => { if (qIn) qIn.value = ''; if (cityIn) cityIn.value = ''; if (catIn) catIn.value = ''; apply(true) }))
      apply(false)
    })
  }

  /* ───────── Galéria (nagyító) ───────── */
  function initGallery(root) {
    $$('[data-kb-gallery]', root).forEach((wrap) => {
      if (wrap.dataset.ready) return
      wrap.dataset.ready = '1'
      const items = $$('[data-full]', wrap)
      const dlg = $('dialog', wrap)
      if (!items.length || !dlg) return
      const img = $('.lb .img img', dlg), counter = $('.lb .top p', dlg)
      let i = 0
      const show = (n) => { i = (n + items.length) % items.length; img.src = items[i].dataset.full; img.alt = items[i].dataset.alt || ''; counter.textContent = `${i + 1} / ${items.length}` }
      items.forEach((b, n) => b.addEventListener('click', () => { show(n); dlg.showModal() }))
      $('.nav.prev', dlg)?.addEventListener('click', () => show(i - 1))
      $('.nav.next', dlg)?.addEventListener('click', () => show(i + 1))
      $('.dlg-close', dlg)?.addEventListener('click', () => dlg.close())
      dlg.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') show(i - 1); if (e.key === 'ArrowRight') show(i + 1) })
      let sx = 0
      dlg.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX }, { passive: true })
      dlg.addEventListener('touchend', (e) => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) show(i + (dx < 0 ? 1 : -1)) })
    })
  }

  /* ───────── 360°-os nézegető (Pannellum, igény szerint betöltve) ───────── */
  const PANNELLUM = 'https://cdn.jsdelivr.net/npm/pannellum@2.5.6/build/'
  let pannLoading = null
  function loadPannellum() {
    if (window.pannellum) return Promise.resolve()
    if (pannLoading) return pannLoading
    pannLoading = new Promise((resolve, reject) => {
      const css = document.createElement('link'); css.rel = 'stylesheet'; css.href = `${PANNELLUM}pannellum.css`; document.head.appendChild(css)
      const s = document.createElement('script'); s.src = `${PANNELLUM}pannellum.js`; s.onload = resolve; s.onerror = reject; document.head.appendChild(s)
    })
    return pannLoading
  }
  function init360(root) {
    $$('[data-kb-360]', root).forEach((btn) => {
      if (btn.dataset.ready) return
      btn.dataset.ready = '1'
      const dlg = document.getElementById(btn.getAttribute('aria-controls'))
      if (!dlg) return
      let viewer = null
      btn.addEventListener('click', async () => {
        dlg.showModal()
        try {
          await loadPannellum()
          if (!viewer) viewer = window.pannellum.viewer($('.viewer', dlg), { type: 'equirectangular', panorama: btn.dataset.kb360, autoLoad: true, showZoomCtrl: true, compass: false, hfov: 100, autoRotate: reduced() ? 0 : -2 })
        } catch (e) { $('.viewer', dlg).innerHTML = '<p style="padding:5rem 1.5rem;text-align:center">A 360°-os nézet most nem tölthető be. Próbáld újra később.</p>' }
      })
      $('.dlg-close', dlg)?.addEventListener('click', () => dlg.close())
    })
  }

  /* ───────── Profilvideó, megosztás ───────── */
  function initMisc(root) {
    $$('[data-kb-play]', root).forEach((b) => {
      if (b.dataset.ready) return
      b.dataset.ready = '1'
      b.addEventListener('click', () => {
        const box = b.closest('.pvideo'), v = $('video', box)
        if (!v) return
        v.controls = true; v.muted = false; v.play().catch(() => {}); b.remove()
      })
    })
    $$('[data-kb-share]', root).forEach((b) => {
      if (b.dataset.ready) return
      b.dataset.ready = '1'
      b.addEventListener('click', async () => {
        const url = location.href.split('#')[0]
        if (navigator.share) { try { await navigator.share({ title: document.title, url }); return } catch { /* mégse */ } }
        try { await navigator.clipboard.writeText(url); toast(b.dataset.copied || 'Link vágólapra másolva') } catch { prompt('Link:', url) }
      })
    })
  }

  function init(root = document) { initHeader(root); initPano(root); initRails(root); initDirectory(root); initGallery(root); init360(root); initMisc(root) }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init())
  else init()
  // Témaszerkesztő: újrainicializálás szakaszbetöltéskor
  document.addEventListener('shopify:section:load', (e) => init(e.target))
})()